import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { SelectCentroCosto } from 'sharedComponents/select'

const CentroCostoNivel1FormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CENTRO NIVEL 1' htmlFor='select-centroCostoNivel1' md={12} />
      <Col md={12}>
        <Field name='_idCentroCostoNivel1'>
          {({ field }) => (
            <SelectCentroCosto {...field} id='select-centroCostoNivel1' isInvalid={iTouched && iError} disabled={fIsSubmitting} nivel={1} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CentroCostoNivel1FormGroup)
